import Footer from "th/footer";

export { Footer };

customElements.define("th-footer", Footer.CustomElementConstructor);
